import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import ClockInOut from '../ClockInOut';
import PAGE_ROUTES, { ROLE_IDS } from '../../utils/constant';
import useCommonDetails from '../../hooks/useCommonDetails';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';
import { useRouter } from '../../hooks/use-router';
import { Logout } from '../../hooks/http-server';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenDialog({
  openDiaLog,
}: {
  openDiaLog: boolean;
}) {
  const [open, setOpen] = React.useState(false);
  const currentUserInfo = useCommonDetails();
  const handleClickOpen = () => {
    setOpen(true);
  };
  const router = useRouter();
  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        Logout();
      })
      .catch((error) => {
        console.error('Error signing out: ', error);
      });
  };
  const handleClose = () => {
    setOpen(false);
  };
  React.useEffect(() => {
    setOpen(openDiaLog);
  }, [openDiaLog]);
  const ROLE_COLORS: Record<number, string> = {
    [ROLE_IDS.ADMIN]: 'red',
    [ROLE_IDS.SUPER_ADMIN]: 'red',
    [ROLE_IDS.MODERATOR]: 'green',
    [ROLE_IDS.TECHLEAD]: 'yellow',
    [ROLE_IDS.TAGGER]: 'default',
  };

  // Function to get role color
  const getRoleColor = (roleId: number) => ROLE_COLORS[roleId] || 'default';

  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar
          sx={{
            position: 'relative',
            backgroundColor: () => {
              return getRoleColor(currentUserInfo.roleId);
            },
          }}
        >
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Action Required: Clock In to Proceed
            </Typography>
            <ClockInOut />
            <Button
              sx={{ color: '#ffffff', whiteSpace: 'nowrap' }}
              onClick={handleLogout}
            >
              Logout
            </Button>
          </Toolbar>
        </AppBar>
        <List>
          <ListItemButton>
            <ListItemText primary="You need to clock in before accessing this page. Please clock in to start your work and continue. If you believe this is an error, contact your administrator" />
          </ListItemButton>
        </List>
      </Dialog>
    </React.Fragment>
  );
}
